import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';
import { Resources } from '../../resource';

function appendTypesParam(qs: URLSearchParams, filter: Record<string, unknown>) {
  const raw = filter.types;
  if (Array.isArray(raw)) {
    raw.forEach((t) => {
      const s = String(t ?? '').trim();
      if (s) qs.append('types', s);
    });
    return;
  }
  const legacy = filter.type;
  if (legacy !== undefined && legacy !== null && String(legacy).trim() !== '') {
    qs.append('types', String(legacy).trim());
  }
}

function appendSocialFollowFilters(qs: URLSearchParams, filter: Record<string, unknown>) {
  appendTypesParam(qs, filter);
  const userId = filter.userId;
  if (userId !== undefined && userId !== null && String(userId).trim() !== '') qs.set('userId', String(userId).trim());
  const walletAddress = filter.walletAddress;
  if (walletAddress !== undefined && walletAddress !== null && String(walletAddress).trim() !== '')
    qs.set('walletAddress', String(walletAddress).trim());
  const socialUsername = filter.socialUsername;
  if (socialUsername !== undefined && socialUsername !== null && String(socialUsername).trim() !== '')
    qs.set('socialUsername', String(socialUsername).trim());
  const fol = filter.isFollowing;
  if (fol === true || fol === 'true') qs.set('isFollowing', 'true');
  else if (fol === false || fol === 'false') qs.set('isFollowing', 'false');
}

class SocialFollowersDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== Resources.blindBoxSocialFollowers) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {} } = params;

    const qs = new URLSearchParams();
    appendSocialFollowFilters(qs, filter as Record<string, unknown>);
    qs.set('limit', String(perPage));
    qs.set('offset', String((page - 1) * perPage));

    const url = `${baseUrl}/blind-box/social-followers?${qs.toString()}`;
    const { json } = await httpClient(url, { method: 'GET' });

    const entries = json?.entries ?? [];
    const total = json?.total ?? 0;
    const data = entries.map((e: any) => ({
      ...e,
      id: `${e.userId}__${e.socialType ?? ''}__${e.socialUsername}`,
    }));
    return { data, total };
  }
}

export const dataProvider = new SocialFollowersDataProvider();

registerModuleDataProvider(Resources.blindBoxSocialFollowers, dataProvider);
